"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSHSNotificationPreferencesComponent = void 0;
const accountsettings_service_1 = require("../../services/accountsettings.service");
const constants = require(".././../../shared/constants");
class CSHSNotificationPreferencesComponent {
    constructor(accountDetailService) {
        this.accountDetailService = accountDetailService;
    }
    ngOnInit() {
        this.getCommunicationPreferenceDetails();
    }
    getCommunicationPreferenceDetails() {
        this.loader = true;
        this.accountDetailService.getCommunicationPreference().subscribe((data) => {
            this.isSubscriptionBilling = (data.accountType === constants.subscriptionBilling);
            this.isEmail = (data.preference === 'EMAIL');
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    setPreference(data) {
        this.accountDetailService.updateCommunicationPreference(data).subscribe((res) => {
            if (res === null || res === void 0 ? void 0 : res.success) {
                this.isEmail = (data === 'EMAIL');
            }
            else {
                this.isEmail = !this.isEmail;
                this.error = true;
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.isEmail = !this.isEmail;
        });
    }
    updateCommunicationPreference(event) {
        this.loader = true;
        this.error = null;
        this.setPreference(event.target.value);
    }
}
exports.CSHSNotificationPreferencesComponent = CSHSNotificationPreferencesComponent;
//# sourceMappingURL=hsnotificationpreferences.component.js.map